export default __webpack_public_path__ + "static/lookbook-1-04db55c097b2b4a6377a301982e277d6.webp";